export default __webpack_public_path__ + "static/media/2.7de00e68.jpg";